
/** Types of data exports that can be done. */
export enum ExportType {
	XLS,
	CSV,
	JSON,
}
